var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgAlertInCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 6.04167C10.9077 6.04167 11.1875 6.32149 11.1875 6.66667V10C11.1875 10.3452 10.9077 10.625 10.5625 10.625C10.2173 10.625 9.9375 10.3452 9.9375 10V6.66667C9.9375 6.32149 10.2173 6.04167 10.5625 6.04167Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 12.0833C10.1023 12.0833 9.72917 12.4565 9.72917 12.9167C9.72917 13.3769 10.1023 13.75 10.5625 13.75C11.0227 13.75 11.3958 13.3769 11.3958 12.9167C11.3958 12.4565 11.0227 12.0833 10.5625 12.0833Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4375 10C2.4375 5.51269 6.07519 1.875 10.5625 1.875C15.0498 1.875 18.6875 5.51269 18.6875 10C18.6875 14.4873 15.0498 18.125 10.5625 18.125C6.07519 18.125 2.4375 14.4873 2.4375 10ZM10.5625 3.125C6.76554 3.125 3.6875 6.20304 3.6875 10C3.6875 13.797 6.76554 16.875 10.5625 16.875C14.3595 16.875 17.4375 13.797 17.4375 10C17.4375 6.20304 14.3595 3.125 10.5625 3.125Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInCircle);
export default __webpack_public_path__ + "static/media/alert-in-circle.7c9741d3c89dee8e3752accfe5cff05a.svg";
export { ForwardRef as ReactComponent };